import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/product.models';
import { ApiService } from './api.service';

export interface SmsGatewayDto {
  id: string;
  name: string;
  simPhoneNumber: string | null;
  isActive: boolean;
  isOnline: boolean;
  dailyLimit: number;
  sentToday: number;
  lastSeenAt: string | null;
  batteryLevel: number | null;
  appVersion: string | null;
  activationCode: string | null;
  activationCodeExpiresAt: string | null;
}

export interface CreateSmsGatewayResult {
  gatewayId: string;
  activationCode: string;
  expiresAt: string;
}

/**
 * SIM kartali Android telefonlar — bitta umumiy park. OTP, qarz eslatmasi,
 * marketing — hammasi bitta navbatga tushadi, istalgan faol qurilma keyingi
 * xabarni oladi. Faqat SuperAdmin ko'radi/boshqaradi.
 */
@Injectable({ providedIn: 'root' })
export class SmsGatewayService extends ApiService {
  private readonly endpoint = `${environment.apiUrl}/api/sms-gateway`;

  getAll(): Observable<ApiResponse<SmsGatewayDto[]>> {
    return this.http.get<ApiResponse<SmsGatewayDto[]>>(this.endpoint);
  }

  create(name: string, dailyLimit?: number): Observable<ApiResponse<CreateSmsGatewayResult>> {
    return this.http.post<ApiResponse<CreateSmsGatewayResult>>(this.endpoint, {
      name,
      dailyLimit: dailyLimit ?? null,
    });
  }

  setActive(id: string, isActive: boolean): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.endpoint}/${id}/active`, { isActive });
  }

  update(
    id: string,
    name: string,
    dailyLimit?: number,
    simPhoneNumber?: string | null,
  ): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(`${this.endpoint}/${id}`, {
      name,
      dailyLimit: dailyLimit ?? null,
      simPhoneNumber: simPhoneNumber?.trim() || null,
    });
  }

  /**
   * Qurilmani qayta ulash uchun yangi faollashtirish kodi chiqaradi (telefon
   * almashtirilganda yoki kalit yo'qolganda). Eski kalit shu zahoti bekor
   * bo'ladi — qurilma qayta skanerlanmaguncha navbatdan xabar ololmaydi.
   */
  reconnect(id: string): Observable<ApiResponse<CreateSmsGatewayResult>> {
    return this.http.post<ApiResponse<CreateSmsGatewayResult>>(
      `${this.endpoint}/${id}/reconnect`,
      {},
    );
  }

  /**
   * Parkni sinash uchun qo'lda SMS navbatga qo'yadi. OTP endi doim Telegram
   * orqali ketadi, shuning uchun bu — gateway'ning uchidan uchigacha
   * ishlashini tekshirishning yagona yo'li.
   */
  sendTest(phoneNumber: string, text?: string): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.endpoint}/test`, {
      phoneNumber,
      text: text?.trim() || null,
    });
  }
}
